export default {"src":"/login-app/[GIT_HASH]/_next/static/media/zoom_out.31ec2b85.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};